import { setObjectValue, Dep } from "../../../framework/Processes";
import { External } from "../../../framework/comp/Lambda/Constructors";
import { FunctionType } from "../../../framework/comp/Types";

export default {
	name: 'task_0_4',
	description: 'Заставка',
	title: 'Режим прохождения игры',
	minigameType: 'Intro',
	generateParams() {
		return {
            question: "Выберите режим прохождения игры",
			options: ["Обучающий", "Контрольный"],
			correct: [0,1]
        };
	},
	postprocess: Dep(External(function(state) {
		const { history } = state.objects;
		const playerChoice = history[history.length - 1].playerAns;
		return setObjectValue("help", playerChoice);
	}, "Function", FunctionType("Object", "Process"))),
	isCompleted: () => true,
};